module.exports = __webpack_public_path__ + "static/img/bg_jjfa.98992b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_jjfa.png
// module id = LPPu
// module chunks = 19